/* eslint-disable jsx-a11y/label-has-associated-control */
import transparentize from 'polished/lib/color/transparentize';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { Kfh_PropertySearchMetaType, Kfh_SearchFacetType } from '../../types/graphqlTypes';
import { getOptions } from '../../utils/getOptions';
import { Select } from '../forms/Select';
import { Loader } from '../Loader';
import { Spacer } from '../Spacer';

interface CommercialSearchFacetsProps {
  facets: Kfh_SearchFacetType;

  parameters: Kfh_PropertySearchMetaType;
  loading: boolean;
}

const StyledLoaderWrap = styled.div`
  ${({ theme: { space, colors, layers } }) => css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${space.lg};
    background-color: ${transparentize(0.2, colors.white.default)};
    z-index: ${layers.bladeOverlay};
  `};
`;

const StyledSpacer = styled(Spacer)`
  position: relative;
`;

export const SearchFacetsCommercial = ({ facets, parameters, loading }: CommercialSearchFacetsProps) => {
  const {
    register,
    formState: { isSubmitting },
  } = useFormContext();
  const propertyTypes =
    facets?.propertyType?.length >= 1
      ? facets.propertyType.map(({ value, facet }) => ({ value: value || facet, name: facet }))
      : [];
  const areas =
    facets?.areas?.length >= 1 ? facets.areas.map(({ value, facet }) => ({ value: value || facet, name: facet })) : [];

  return (
    <StyledSpacer spacing="half">
      {loading && (
        <StyledLoaderWrap>
          <Loader />
        </StyledLoaderWrap>
      )}

      {areas.length >= 1 && (
        <Select
          id="commercialArea"
          label="Location"
          {...register('commercialArea', {})}
          placeholder="All"
          options={areas}
          disabled={isSubmitting}
        />
      )}
      <Select
        id="commercialSize"
        label="Min size (Sq.m)"
        {...register('commercialSize', {
          valueAsNumber: true,
        })}
        options={getOptions(parameters?.commercialMinimumSize)}
        disabled={isSubmitting}
      />
      <Select
        id="commercialSizemax"
        label="Max size (Sq.m)"
        {...register('commercialSizemax', {
          valueAsNumber: true,
        })}
        options={getOptions(parameters?.commercialMaximumSize)}
        disabled={isSubmitting}
      />
      {propertyTypes.length >= 1 && (
        <Select
          id="commercialPropertyType"
          label="Property type"
          {...register('commercialPropertyType', {})}
          placeholder="All"
          options={propertyTypes}
          disabled={isSubmitting}
        />
      )}
    </StyledSpacer>
  );
};
